import { render, staticRenderFns } from "./logisticsPersonalFile.vue?vue&type=template&id=7c3869c5&"
import script from "./logisticsPersonalFile.vue?vue&type=script&lang=js&"
export * from "./logisticsPersonalFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports